/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-10 11:01:00
 * @LastEditors: caiqin.xie
 * @message: FAQs-快速搜索分类组件
 */
import React from "react";
import { Select } from '@arco-design/web-react';
import styles from "../../index.module.scss";

interface ISelectOption{
  id: string;
  labelName: string;
}
interface IProps {
  ctry: string;
  words: Record<string, string>;
  device: string;
  currentLabelName: string; // 当前选中的标签
  quickSearchList: ISelectOption[]; // 快速搜索列表
  setCurrentLabelName: (labelName: string) => void; // 设置当前选中的标签
  getList:(labelName: string)=>void; // 获取faq列表
}
const Option = Select.Option;
const QuickSearch = (props:IProps) => {
  const { ctry, words, device, currentLabelName, setCurrentLabelName, quickSearchList, getList } = props
  return (
    <>
      {/* 快捷搜索 PC */}
      {device === 'pc' && (
        <div className={styles['question-nav-wrap']}>
          {quickSearchList?.map((item, index) => (
            <a 
              className={`${styles['question-nav-item']} ${currentLabelName===item.labelName &&  styles['question-nav-active']}`}
              onClick={() => { getList(item.labelName); setCurrentLabelName(item.labelName)}}
              key={item.labelName}>
                {item.labelName}
              {/* { words && words[item.name] } */}
            </a>
          ))}
        </div>
      )}
      {/* 快捷搜索 移动 */}
      {device !== 'pc' && (
        <div className={styles['question-nav-wrap']}>
          <Select placeholder='Select' value={currentLabelName} size="large" onChange ={(labelName:string) => {getList(labelName);setCurrentLabelName(labelName)}}>
            {quickSearchList?.map((option, index) => (
              <Option key={option.id} value={option.labelName}>
                {option.labelName}
                {/* { words && words[option.name] }  */}
              </Option>
            ))}
          </Select>
        </div>
      )}
    </>
  )
}
export default QuickSearch